// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-row {
  height: max-content;
}

.text-row h2 {
  font-size: 2.2rem;
  margin-bottom: 0.8rem;
}

.text-row p {
  font-size: 1.2rem;
  text-align: justify;
  text-indent: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/PoliticaPrivacidade/index.modules.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".text-row {\n  height: max-content;\n}\n\n.text-row h2 {\n  font-size: 2.2rem;\n  margin-bottom: 0.8rem;\n}\n\n.text-row p {\n  font-size: 1.2rem;\n  text-align: justify;\n  text-indent: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
